module.exports = __webpack_public_path__ + "assets/atlassian-confluence.4a1c9d20.svg";